import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '../ButtonComponent';
import { BASE_URL } from '../../../config/environmentConfig';

export const ApplicationViewConfirmModal: FC = () => {

  return (
    <div className="d-flex flex-column align-items-center justify-content-center px-8 pb-5">
      <FontAwesomeIcon icon={faCircleCheck} width={40} className="h-40px" />
      <div className="fs-2 fw-bolder my-5">Thank you for submitting your details!</div>
      <span className="fs-6">We are now processing them and we’ll activate</span>
      <span className="fs-6">your account in no time.</span>
      {/*<div className="fs-6 mb-10">In the meantime, why not to get ahead and start your integration?</div>*/}
      {/*<ButtonComponent additionalClass="btn-sm">*/}
      {/*  <a*/}
      {/*    href={BASE_URL.DOCS_URL}*/}
      {/*    target="_blank"*/}
      {/*    className="fs-6 link-styles text-white"*/}
      {/*    rel="noreferrer"*/}
      {/*  >*/}
      {/*    Read the documentation*/}
      {/*  </a>*/}

      {/*</ButtonComponent>*/}
    </div>
  );
};
